export default __webpack_public_path__ + "static/19-f37e873db2b6bbdf502e5b7113db88dd.webp";